
<div class="sidebar">
	<app-sidebar-header title=" ">
		<div custom-label>
		<app-svg class="logo__economyxtra" [alt]="'economyExtraSidebar.alt.economyExtraLogo' | ibeadmin | async" svg="sprite.svg#logo--economy_extra" aria-hidden="true"></app-svg>
		</div>
	</app-sidebar-header>
	<div class="sidebar__body sl--scrollable">
		<h2 class="title-h2">{{ 'economyExtraSidebar.title.economyExecutive' | ibeadmin | async }}</h2>
		<!-- <app-gallery></app-gallery> -->
		<app-simple-gallery [photos]="photosGallery"></app-simple-gallery>
		<!-- <h3 class="title-h2">{{ 'economyExtraSidebar.title.meals' | ibeadmin | async }}</h3>
		<table class="table table--align-left responsive">
			<caption class="hidden">{{ 'economyExtraSidebar.text.mealAvailable' | ibeadmin | async }}</caption>
			<thead>
					<tr>
							<th>{{ 'economyExtraSidebar.text.flightDuration' | ibeadmin | async }}</th>
							<th>{{ 'economyExtraSidebar.text.mealTime' | ibeadmin | async }}</th>
							<th>{{ 'economyExtraSidebar.text.mealType' | ibeadmin | async }}</th>
					</tr>
			</thead>
			<tbody>
					<tr>
							<td>{{ 'economyExtraSidebar.text.under3h' | ibeadmin | async }}</td>
							<td>{{ 'economyExtraSidebar.text.allSched' | ibeadmin | async }}</td>
							<td class="with-icon"><app-svg [svg]="'icons.svg#food_drinks--cold_meals'" [alt]="'economyExtraSidebar.alt.coldSnack' | ibeadmin | async" [attr.aria-label]="'economyExtraSidebar.aria.coldSnackIcon' | ibeadmin | async"></app-svg>{{ 'economyExtraSidebar.text.coldSnack' | ibeadmin | async }}</td>
					</tr>
					<tr>
							<td rowspan="2">{{ 'economyExtraSidebar.text.3hto4h' | ibeadmin | async }}</td>
							<td>{{ 'economyExtraSidebar.text.flyingTo' | ibeadmin | async }} <span class="description">{{ 'economyExtraSidebar.text.time' | ibeadmin | async }}</span></td>
							<td class="with-icon"><app-svg [svg]="'icons.svg#food_drinks--hot_meals'" [alt]="'economyExtraSidebar.alt.hotMeal' | ibeadmin | async" [attr.aria-label]="'economyExtraSidebar.aria.hotMeal' | ibeadmin | async"></app-svg>{{ 'economyExtraSidebar.text.hotMeal' | ibeadmin | async }}</td>
					</tr>
					<tr>
						<td>{{ 'economyExtraSidebar.text.otherSchedule' | ibeadmin | async }}</td>
						<td class="with-icon"><app-svg [svg]="'icons.svg#food_drinks--cold_meals'" [alt]="'economyExtraSidebar.alt.coldSnack' | ibeadmin | async" [attr.aria-label]="'economyExtraSidebar.aria.coldSnackIcon' | ibeadmin | async"></app-svg>{{ 'economyExtraSidebar.text.coldSnack' | ibeadmin | async }}</td>
					</tr>
					<tr>
							<td>{{ 'economyExtraSidebar.text.4hAndMore' | ibeadmin | async }}</td>
							<td>{{ 'economyExtraSidebar.text.allSchedule' | ibeadmin | async }}</td>
							<td class="with-icon"><app-svg [svg]="'icons.svg#food_drinks--hot_meals'" [alt]="'economyExtraSidebar.alt.hotMeal' | ibeadmin | async" [attr.aria-label]="'economyExtraSidebar.aria.hotMeal' | ibeadmin | async"></app-svg>{{ 'economyExtraSidebar.text.hotMeal' | ibeadmin | async }}</td>
					</tr>
			</tbody>
		</table> -->
		<h3 class="title-h2">{{ 'economyExtraSidebar.text.compareSeatingAreas' | ibeadmin | async }}</h3>
		<table class="table table--align-left responsive">
			<caption class="hidden">{{ 'economyExtraSidebar.text.differencesTable' | ibeadmin | async }}</caption>
			<thead>
					<tr>
							<th><app-svg [attr.aria-label]="'economyExtraSidebar.aria.economyExtra' | ibeadmin | async" class="logo__economyxtra" [alt]="'economyExtraSidebar.alt.economyExtraLogo' | ibeadmin | async" svg="sprite.svg#logo--economy_extra" aria-hidden="true"></app-svg></th>
							<th>{{ 'economyExtraSidebar.text.emergencyRow' | ibeadmin | async }}</th>
							<th>{{ 'economyExtraSidebar.text.standard' | ibeadmin | async }}</th>
					</tr>
			</thead>
			<tbody>
					<tr>
						<td><span class="hidden-mobile">✔︎</span> 33" {{ 'economyExtraSidebar.text.legroom' | ibeadmin | async }}</td>
						<td><span class="hidden-mobile">✔︎</span> 28" {{ 'economyExtraSidebar.text.legroom' | ibeadmin | async }}</td>
						<td><span class="hidden-mobile">✔︎</span> 33" {{ 'economyExtraSidebar.text.legroom' | ibeadmin | async }}</td>
					</tr>
					<tr>
						<td><span class="hidden-mobile">✔︎</span>  4" {{ 'economyExtraSidebar.text.recline' | ibeadmin | async }}</td>
						<td><span class="hidden-mobile">✔︎</span>  8.4" {{ 'economyExtraSidebar.text.recline' | ibeadmin | async }}</td>
						<td><span class="hidden-mobile">✔︎</span>  33" {{ 'economyExtraSidebar.text.legroom' | ibeadmin | async }}</td>
					</tr>
					<tr>
						<td><span class="hidden-mobile">✔︎</span>  33" {{ 'economyExtraSidebar.text.legroom' | ibeadmin | async }}</td>
						<td><span class="hidden-mobile">✔︎</span>  {{ 'economyExtraSidebar.text.seatWidth' | ibeadmin | async }}</td>
						<td><span class="hidden-mobile">✔︎</span>  33" {{ 'economyExtraSidebar.text.legroom' | ibeadmin | async }}</td>
					</tr>
					<tr>
						<td><span class="hidden-mobile">✔︎</span>  33" {{ 'economyExtraSidebar.text.legroom' | ibeadmin | async }}</td>
						<td class="muted"><span class="hidden-mobile">✗&nbsp;</span>   <span class="line-through">{{ 'economyExtraSidebar.text.coatHooks' | ibeadmin | async }}</span></td>
						<td><span class="hidden-mobile">✔︎</span>  33" {{ 'economyExtraSidebar.text.legroom' | ibeadmin | async }}</td>
					</tr>
					<tr>
						<td><span class="hidden-mobile">✔︎</span>  33" {{ 'economyExtraSidebar.text.legroom' | ibeadmin | async }}</td>
						<td class="muted"><span class="hidden-mobile">✗&nbsp;</span>  <span class="line-through">{{ 'economyExtraSidebar.text.adjustableHeadrest' | ibeadmin | async }}</span></td>
						<td><span class="hidden-mobile">✔︎</span>  33" {{ 'economyExtraSidebar.text.legroom' | ibeadmin | async }}</td>
					</tr>
					<tr>
						<td><span class="hidden-mobile">✔︎</span>  33" {{ 'economyExtraSidebar.text.legroom' | ibeadmin | async }}</td>
						<td class="muted"><span class="hidden-mobile">✗&nbsp;</span>  <span class="line-through">{{ 'economyExtraSidebar.text.powerAndUSBPlugs' | ibeadmin | async }}</span></td>
						<td><span class="hidden-mobile">✔︎</span>  33" {{ 'economyExtraSidebar.text.legroom' | ibeadmin | async }}</td>
					</tr>
			</tbody>
		</table>
		<a class="link link--close" [attr.aria-label]="'economyExtraSidebar.aria.closeSidebar' | ibeadmin | async" (click)="TAP_handleClose()" href="javascript:;" role="button">{{ 'economyExtraSidebar.text.closeThisWIndow' | ibeadmin | async }}</a>
	</div>
</div>
